module.exports = __webpack_public_path__ + "static/media/mind-middle-left.ee728d4e.svg";